import { render } from "./WCOrderTypeCard.vue?vue&type=template&id=4bf4b7ec&scoped=true"
import script from "./WCOrderTypeCard.vue?vue&type=script&lang=js"
export * from "./WCOrderTypeCard.vue?vue&type=script&lang=js"

import "./WCOrderTypeCard.vue?vue&type=style&index=0&id=4bf4b7ec&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf4b7ec"]])

export default __exports__